import { CompaniesIcon, RolesIcon, UserIcon } from "allIcons";

export const usersMenu = (app_users_view_users) =>
  [
    app_users_view_users && {
      title: "users.menu.teamMebers",
      module: "team-members",
      icon: <UserIcon />,
    },
    app_users_view_users && {
      title: "users.menu.clients",
      module: "clients",
      icon: <UserIcon />,
    },
    {
      title: "users.menu.roles",
      module: "roles",
      icon: <RolesIcon />,
    },
    // Here for future use
    // {
    //   title: "users.menu.groups",
    //   module: "groups",
    //   icon: <GroupIcon />,
    // },
    {
      title: "users.menu.companies",
      module: "companies",
      icon: <CompaniesIcon />,
    },
  ].filter((_) => _);
